import NiceModal from '@ebay/nice-modal-react';
import { enqueueSnackbar } from 'notistack';
import { any, defaultTo } from 'ramda';
import { isNilOrEmptyString } from 'ramda-extension';

import { resetForm } from '@gef-ui/form-core/stream/transfer/control';
import { getMessage } from '@gef-ui/localization/messages';

import MODALS from 'constants/modals';
import fetch from 'features/common/fetch';

import { ORDER_FORM_NAME } from './form';
import { getContactOrdersList } from './selectors';
import { reset, saveContactOrder } from './slice';

export const fetchContactOrder =
	(campaignId) =>
	async (dispatch, getState, { getFormData }) => {
		const formData = await getFormData(ORDER_FORM_NAME);

		if (any(isNilOrEmptyString)([formData?.region, formData?.agency])) {
			return dispatch(reset());
		}

		dispatch(
			fetch.actions.get(fetch.constants.urls.campaignOrder, {
				uniqueReqID: 'get',
				takeLatest: true,
				replaceParams: { id: campaignId },
				queryParams: {
					regionId: formData?.region,
					agencyId: formData?.agency,
				},
				onSuccess: [
					(response) => () => {
						const data = response.body.data;
						if (!data || !Array.isArray(data)) return;
						const orders = data.map((order) => ({
							...order,
							orderedLeads: defaultTo(0)(order.orderedLeads),
						}));
						dispatch(saveContactOrder(orders));
					},
				],
			}),
		);
	};

export const saveContactOrders = (campaignId) => (dispatch, getState) => {
	dispatch(
		fetch.actions.put(fetch.constants.urls.campaignOrder, {
			uniqueReqID: 'put',
			replaceParams: { id: campaignId },
			body: {
				orders: getContactOrdersList(getState()),
			},
			onSuccess: [
				() => () => {
					enqueueSnackbar(getMessage('toastr:contactOrderSave'), { variant: 'success' });
					NiceModal.hide(MODALS.order);
				},
			],
		}),
	);
};

export const resetFilters =
	() =>
	(dispatch, getState, { sendControlNext }) => {
		dispatch(reset());
		sendControlNext(ORDER_FORM_NAME, resetForm());
	};
